import MonitoringDetailController from './monitoring.detail.controller';

export default {
    template: require('./monitoring.detail.html'),
    controller: MonitoringDetailController
};
